export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/agency-news',
        name: 'AgencyNews',
        component: () => import('./AgencyNews.page.vue'),
        props: true,
        meta: {
          title: 'TITLE__AGENCY_NEWS',
          template: 'Main',
          isAuthentication: true,
        },
        children: [
          {
            path: '/',
            name: 'AgencyNewsDefault',
            component: () => import('./AgencyNews.default.vue'),
            props: true,
            meta: {
              title: 'TITLE__AGENCY_NEWS',
              template: 'Main',
              isAuthentication: true,
            },
          },
          {
            path: 'add',
            name: 'AgencyNewsAdd',
            component: () => import('./Add/Add.page.vue'),
            props: true,
            meta: {
              title: 'TITLE__AGENCY_NEWS',
              template: 'Main',
              isAuthentication: true,
            },
          },
          {
            path: ':id',
            name: 'AgencyNewsEdit',
            component: () => import('./Item/Item.page.vue'),
            props: true,
            meta: {
              title: 'TITLE__AGENCY_NEWS',
              template: 'Main',
              isAuthentication: true,
            },
          },
        ],
      },
    ]);
  },
};
